// Banner
import BannerImg from '@/images/about/banner/banner.jpg';

// Benefits
import CardIcon from '@/assets/svg/icons/card.svg';
import DnaIcon from '@/assets/svg/icons/dna.svg';
import HardwareIcon from '@/assets/svg/icons/hardware.svg';

// Swiper
import Slide1992 from '@/images/about/swiper/1992.png';
import Slide1997 from '@/images/about/swiper/1997-logo.png';
import Slide2003 from '@/images/about/swiper/2003.png';
import Slide2004 from '@/images/about/swiper/2004-logo.png';
import Slide2005 from '@/images/about/swiper/2005.png';
import Slide2017 from '@/images/about/swiper/2017.png';
import Slide2018 from '@/images/about/swiper/2018.png';

// Industry
import Hall from '@/images/about/industry/hall.jpg';
import LogoMicrosoft from '@/images/about/industry/logos/microsoft-gold-partner-logo.png';
import LogoIfst from '@/images/about/industry/logos/ifst-logo.png';
import LogoCitec from '@/images/about/industry/logos/citec-logo.png';
import LogoCecod from '@/images/about/industry/logos/cecod-logo.png';

// Leadership
import Slide1 from '@/images/about/leadership/slide-1.jpg';
import Slide2 from '@/images/about/leadership/slide-2.jpg';

// Careers
import ImgMeeting from '@/images/about/careers/meeting.jpg';

const AboutData = {
  hero: {
    page_name: 'About us',
    title: 'We change technology landscapes for',
    marked_title: 'modern efficient retail ',
    description:
      'CiRRUS simplifies your business operations with state-of-the-art  software to reduce operating costs and foster competitiveness and innovation.',
  },
  glance: {
    subtitle: 'CiRRUS at Glance',
    title:
      'CiRRUS is a part of BiCA — a reliable & trusted partner for modern technology solutions',
    markered: 'BiCA',
    statistics: [
      {
        number: '450000+',
        desc:
          'transactions daily are made in through CiRRUS  software for Gas stations',
      },
      {
        number: '540+ POS',
        desc: 'are running on CiRRUS / BiCA software and hardware solutions',
      },
      {
        number: '10 countries',
        desc: 'we are operate in, 5 languages supports',
      },
    ],
  },
  banner: {
    img: BannerImg,
    sescription: "BICA's office in Lucerne, Switzerland",
  },
  benefits: [
    {
      icon: CardIcon,
      title: 'Changing and developing the retail industry for almost 60 years',
      description:
        'Family-owned business (Lantzerath-Group) with partnership values brought througout generations ',
    },
    {
      icon: DnaIcon,
      title: 'Excellence & trustful relations is in our DNA',
      description:
        'CiRRUS/BiCA AG is family-owned company (Lantzerath-Group) with partnership values brought througout generations ',
    },
    {
      icon: HardwareIcon,
      title: 'Experts in software and hardware solutions for retail',
      description:
        'Family-owned business (Lantzerath-Group) with partnership values brought througout generations ',
    },
  ],
  business: {
    header: {
      title: 'Serving retailing business ',
      description:
        'Established 1962 and still headquartered in Lucerne, Switzerland, BiCA AG is a leading provider of POS technology for gas stations, c-stores/retail and the hospitality industry.',
    },
    swiper: [
      {
        title: '1962',
        description: 'Gründung der Albrecht und Meyer & Co heute BiCA AG',
      },
      {
        title: '1971',
        description:
          'Gründung der ersten Lantzerath-Gesellschaft in Deutschland als Installationsbetrieb für Elektrotechnik gegründet.',
      },
      {
        title: '1992',
        description:
          'Gründung der ersten Lantzerath-Gesellschaft in Frankreich🇫.',
        background: Slide1992,
      },
      {
        title: '1997',
        description:
          'BiCA AG wird Teil der Lantzerath-Group und zum Systemhaus gewandelt',
        logo: Slide1997,
      },
      {
        title: '2003',
        description:
          'EOP GmbH wird Teil der Lantzerath-Group und zu BiCA (Austria) GmbH gewandelt.',
        background: Slide2003,
      },
      {
        title: '2004',
        description:
          'TOPTEQ Tankstellentechnik GmbH wird Teil der Lantzerath-Group',
        logo: Slide2004,
      },
      {
        title: '2005',
        description:
          'Gründung der ersten Lantzerath-Gesellschaft in Belgien 🇧🇪',
        background: Slide2005,
      },
      {
        title: '2013',
        description:
          'BiCA AG beteiligt sich an CODAB in Schweden und vereinbart eine strategische Allianz',
      },
      {
        title: '2017',
        description:
          'BiCA AG gründet erste Gesellschaft in USA im Silicon Valley🇺🇸',
        background: Slide2017,
      },
      {
        title: '2018',
        description: 'BiCA AG beteiligt sich an a2i systems in Dänemark',
        background: Slide2018,
      },
    ],
  },
  research: {
    subtitle: 'Research and Development',
    title: 'Born in Switzerland, emerging in Sylicon Valley',
    description:
      'Here at CiRRUS we take the best of two worlds: precision and excellence of Swiss engeneering and delightful User experience philosophy which is Silycon Valley is famous for. ',
    point_a: {
      title: 'CiRRUS US R&D Centre, Palo Alto, CA',
      list: [
        'Software design',
        'Developemnt of Hospitality Module',
        'Product development',
      ],
    },
    point_b: {
      title: 'CiRRUS/BiCA AG Lucerne, Switzerland',
      list: ['Software design', 'Engeneering'],
    },
  },
  industry: {
    picture: Hall,
    title: 'Building together a',
    title_markered: 'strong retail industry',
    description:
      'BICA is committed to making consistent and sustainable efforts to improve the IT sector and strengthen  communities in the regions where it operates. ',
    list: [LogoMicrosoft, LogoIfst, LogoCitec, LogoCecod],
  },
  leadership: {
    subtitle: 'Leadership',
    title: 'You are in a good company',
    description:
      'We aare proud of our stellar team of globally recognized leaders committed to deliver outstanding and gamechanging solutions for the retail industry',
    swiper: [Slide1, Slide2, Slide1, Slide2, Slide1, Slide2],
  },
  careers: {
    subtitle: 'Careers',
    title: 'Great companies are made by great people',
    description:
      'Working CiRRUS is an opportunity to learn, grow and make an impact on how modern retail business will operate.',
    image: ImgMeeting,
  },
  connect: {
    description:
      'Connect to our LinkedIn account and get inspired from the latest industry news, case studies, tech advises and many more!',
    button: {
      text: 'LinkedIn Connect ',
      icon: 'linked-in',
      modifier: 'blue',
    },
  },
  blog: {
    subtitle: 'Our blog',
    title: 'Learn more about how CiRRUS is changing the POS industry',
  },
};

export default AboutData;
